import { Spinner } from "@hulahoop/ui";
import { useTranslation } from "react-i18next";
import { FullScreenCenter } from "@/components/shared/layout/FullScreenCenter";

export function LoadingScreen({ message }: { message?: string }) {
  const { t } = useTranslation(undefined, { useSuspense: false });
  return (
    <FullScreenCenter
      role="status"
      aria-live="polite"
      aria-label={message ?? t("foundation.loading")}
      className="gap-3"
    >
      <span aria-hidden="true">
        <Spinner />
      </span>
      <span>{message ?? t("foundation.loading")}</span>
    </FullScreenCenter>
  );
}
